module.exports = __webpack_public_path__ + "01_short_beige.c11cf1ed.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/01_short_beige.png
// module id = KfU8
// module chunks = 0